import environmentDefault from './environment.default';

export const environment: any = {
  ...environmentDefault,

  // URLs
  SERVER_URL: 'https://testing.schnapsen.online',
  API_SERVER_URL: 'https://testing.schnapsen.online/api',
  DICEBEAR_API_URL:
    'https://testing.schnapsen.online/api/dicebear/9.x/adventurer/svg',
};
